import React, { useState } from "react";
import { Logo } from "components/logo";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Divider,
  Form,
  Grid,
  GridColumn,
  Header,
  Message,
  Segment,
} from "semantic-ui-react";
import { AppService, loginDto } from "services";

import { Formik } from "formik";
import * as Yup from "yup";

export const LoginPage = () => {
  const [status, setStatus] = useState({ success: false, error: false });
  const navigate = useNavigate();

  const submit = async (body: loginDto) => {
    setStatus({ success: false, error: false });
    try {
      await AppService.login(body as loginDto);
      setStatus({ error: false, success: true });
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } catch (error) {
      setStatus({ success: false, error: true });
    }
  };

  return (
    <Grid
      textAlign="center"
      verticalAlign="middle"
      style={{ height: "100vh" }}
      container
    >
      <Grid.Column width="16">
        <Segment style={{ height: "100%", width: "100%" }}>
          <Grid
            columns={2}
            textAlign="center"
            verticalAlign="middle"
            style={{
              minHeight: "30rem",
              width: "100%",
              height: "100%",
              margin: 0,
            }}
          >
            <Divider vertical />

            <GridColumn
              as="div"
              mobile={16}
              computer={8}
              style={{ height: "100%" }}
            >
              <Logo size="medium" as={Link} to="/" />
            </GridColumn>

            <GridColumn mobile={16} computer={8}>
              <Header
                as="h1"
                style={{ fontSize: "3rem", marginBottom: "2rem" }}
              >
                Baromètre de satisfaction
              </Header>
              <Formik
                initialValues={{ username: "", password: "" }}
                onSubmit={async (values) => {
                  await submit(values);
                }}
                validationSchema={Yup.object().shape({
                  username: Yup.string().required().min(5),
                  password: Yup.string().required().min(4),
                })}
              >
                {(props) => {
                  const {
                    values,
                    touched,
                    errors,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                  } = props;
                  return (
                    <Form size="large" onSubmit={handleSubmit}>
                      <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder="Entrer votre username"
                        disabled={isSubmitting}
                        id="username"
                        name="username"
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          errors.username && touched.password
                            ? {
                                content: "Le nom d'utilisateur est requis",
                                pointing: "below",
                              }
                            : false
                        }
                      />
                      <Form.Input
                        fluid
                        icon="lock"
                        iconPosition="left"
                        placeholder="Mot de passe"
                        type="password"
                        id="password"
                        name="password"
                        disabled={isSubmitting}
                        value={values.password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          errors.password && touched.password
                            ? {
                                content: "Le mot de passe est requis",
                                pointing: "below",
                              }
                            : false
                        }
                      />

                      {status.success && (
                        <Message color="green">
                          <p>Connecté avec succès</p>
                        </Message>
                      )}
                      {status.error && (
                        <Message color="red">
                          <p>Non utilisateur ou mot de passe incorrect</p>
                        </Message>
                      )}

                      <Button
                        primary
                        fluid
                        size="large"
                        type="submit"
                        content="Se connecter"
                        disabled={isSubmitting}
                        loading={isSubmitting}
                      >
                        Se connecter
                      </Button>
                    </Form>
                  );
                }}
              </Formik>
            </GridColumn>
          </Grid>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};
